import { useEffect } from "react";
import { Link } from "react-router-dom";
import { BRIEFINGS } from "@/data/briefings";
import { PageShell } from "@/components/ds";
import { Reveal } from "@/components/site/Reveal";
import { NewsletterForm } from "@/components/ds/NewsletterForm";
import { setPageMeta } from "@/lib/seo";

const InsightsIndex = () => {
  useEffect(() => {
    setPageMeta({
      title: "Insights & Desk Briefings — Zorem Commodities",
      description: "Physical gold market intelligence: Dubai buying guides, doré payable rates, corridor analysis, and compliance-driven pricing — from the Zorem desk.",
      path: "/insights",
    });
  }, []);

  return (
    <div data-testid="insights-index">
      <PageShell eyebrow="Insights & Briefings" title="Desk notes from the physical market.">
        <div className="grid md:grid-cols-2 gap-px bg-[#C9A227]/15 card-line -mt-4">
          {BRIEFINGS.map((a, i) => (
            <Reveal key={a.slug} delay={i * 0.05}>
              <Link to={`/insights/${a.slug}`} data-testid={`index-card-${a.slug}`}
                className="block group bg-[#0A0A0B] p-9 h-full hover:bg-[#16161A] transition-colors">
                <span className="font-mono2 text-[10px] uppercase tracking-[0.25em] text-zinc-400">{a.date}</span>
                <h2 className="mt-4 font-display text-lg text-white tracking-wide leading-snug group-hover:text-[#E8C85A] transition-colors">
                  {a.title}
                </h2>
                <p className="mt-3 text-sm text-zinc-400 leading-relaxed line-clamp-3">{a.dek}</p>
                <span className="mt-5 inline-block text-[11px] uppercase tracking-[0.22em] text-[#C9A227]">Read →</span>
              </Link>
            </Reveal>
          ))}
        </div>
        <div className="mt-12">
          <NewsletterForm testid="insights-newsletter" />
        </div>
      </PageShell>
    </div>
  );
};

export default InsightsIndex;
